// extracted by mini-css-extract-plugin
export var active = "simple-tab-module--active--75c8d";
export var hidden = "simple-tab-module--hidden--c442c";
export var tabs = "simple-tab-module--tabs--b577a";